import React from "react";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useDispatch, useSelector } from "react-redux";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { Link } from "react-router-dom";
import data from "../../components/shared/header/data.json";

import {
  setCompetitionsTabStr,
  setReportsTabStr,
  setReservoirsTabStr,
} from "../../redux/slice/sliceHome";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import footerMiddleData from "../../components/shared/footer/FooterMiddle.json";
import footerBottomData from "../../components/shared/footer/FooterBottom.json";
import footerTopData from "../../components/shared/footer/FooterTopData.json";

const Sitemap = () => {
  const dispatch = useDispatch();
  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();

  const getPath = (path) => {
    const segments = path.split("/");
    if (segments[1] === "neepco") {
      return "/" + segments.slice(2).join("/");
    }
    return path;
  };

  const { data: ṃenus = {} } = useGetProtectedApiDataQuery({
    url: "mastermenu",
    lang: languageType,
  });

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="/images/inner_aboutbann.jpg"
        title={getText("Sitemap", "साइट मैप")}
        titleLink="/screen-reader"
        levelTwo={false}
        levelThree={false}
        isActive={getText("Sitemap", "साइट मैप")}
      />
      <div className="inner-container">
        <div className="container">
          <div className="container about_inntxt">
            <div className="row">
              <div className="container important-links">
                <ul className="inn_list list_cstar">
                  {/* menus */}
                  {ṃenus?.menu_items?.map((item) => (
                    <li className="expanded">
                      {item.children ? (
                        <a href="#" onClick={(e) => e.preventDefault()}>
                          {item.title}
                        </a>
                      ) : (
                        <Link to={getPath(item.url)}>{item.title}</Link>
                      )}
                      {item.children && (
                        <ul className="site-map-menu mt-2">
                          {item.children.map((subitem) => (
                            <li className="first leaf">
                              <Link to={getPath(subitem.url)}>
                                {subitem.title}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))}

                  {/* footer top menus */}
                  {footerTopData.map((item) => (
                    <li className="leaf">
                      <Link to={item.link}>
                        {getText(item.title, item.translation)}
                      </Link>
                    </li>
                  ))}

                  {/* footer middle menus */}
                  {footerMiddleData.map((item) => (
                    <li className="leaf">
                      {item.link.startsWith("https") ? (
                        <a
                          href={item.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {getText(item.title, item.translation)}
                        </a>
                      ) : (
                        <Link to={item.link}>
                          {getText(item.title, item.translation)}
                        </Link>
                      )}
                    </li>
                  ))}

                  {/* footer bottom menus */}
                  {footerBottomData.map((item) => (
                    <li className="leaf">
                      <Link to={item.link}>
                        {getText(item.title, item.translation)}
                      </Link>
                    </li>
                  ))}
                  {/* <>
                    <li className="expanded">
                      <a href="#" onClick={(e) => e.preventDefault()}>
                        {getText("Reservoir Status", "जलाशय स्थिति")}
                      </a>
                      <ul className="site-map-menu">
                        <li className="first leaf">
                          <Link
                            to="/reservoir-status"
                            onClick={() =>
                              dispatch(setReservoirsTabStr("Water Levels"))
                            }
                          >
                            {getText("Water Level", "जल स्तर")}
                          </Link>
                        </li>
                        <li className="last leaf">
                          <Link
                            to="/reservoir-status"
                            onClick={() =>
                              dispatch(setReservoirsTabStr("Rain Fall Data"))
                            }
                          >
                            {getText("Rain Fall", "वर्षा स्तर")}
                          </Link>
                        </li>
                      </ul>
                    </li>

                    <li className="first expanded">
                      <a href="#" onClick={(e) => e.preventDefault()}>
                        {getText("Reports", "रिपोर्ट")}
                      </a>
                      <ul className="site-map-menu">
                        <li className="first leaf">
                          <Link
                            to="/reports"
                            onClick={() =>
                              dispatch(setReportsTabStr("annual-report"))
                            }
                          >
                            {getText("Annual Reports", "वार्षिक रिपोर्ट")}
                          </Link>
                        </li>
                        <li className="last leaf">
                          <Link
                            to="/reports"
                            onClick={() => dispatch(setReportsTabStr("mou"))}
                          >
                            {getText("MOU", "समझौता ज्ञापन")}
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className="leaf">
                      <Link
                        to="/sustainable-development/swachh-bharat-abhiyan"
                        id="newicon"
                      >
                        {getText("Swachh Bharat", "स्वच्छ भारत")}
                      </Link>
                    </li>
                    <li className="leaf">
                      <a
                        href="#"
                        id="newicon"
                        onClick={(e) => e.preventDefault()}
                      >
                        {getText(
                          "Competitions And Celebration",
                          "प्रतियोगिताएं और उत्सव"
                        )}
                      </a>
                      <ul className="site-map-menu">
                        <li className="first leaf">
                          <Link
                            to="/painting-competition"
                            onClick={() =>
                              dispatch(
                                setCompetitionsTabStr("painting-competition")
                              )
                            }
                          >
                            {getText(
                              "BEE Painting Competition",
                              "चित्रकला प्रतियोगिता"
                            )}
                          </Link>
                        </li>
                        <li className="leaf">
                          <Link
                            to="/competition-celebrations"
                            onClick={() =>
                              dispatch(
                                setCompetitionsTabStr("other-ceremonies")
                              )
                            }
                          >
                            {getText("Other Celebrations", "अन्य समारोह")}
                          </Link>
                        </li>
                        <li className="last leaf">
                          <Link
                            to="/competition-celebrations"
                            onClick={() =>
                              dispatch(setCompetitionsTabStr("amrit"))
                            }
                          >
                            {getText(
                              "Azadi Ka Amrit Mahotsav",
                              "आजादी का अमृत महोत्सव"
                            )}
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className="leaf">
                      <Link to="/contact-us">
                        {getText("Contact Us", "हमसे संपर्क करें")}
                      </Link>
                    </li>
                    <li className="last leaf">
                      <Link to="/covid-19">
                        {getText("Covid-19", "कोविड-19")}
                      </Link>
                    </li>
                    <li className="leaf">
                      <Link to="/rti">{getText("RTI", "सूचना का अधिकार")}</Link>
                    </li>

                    <li className="leaf">
                      <Link to="/feedback">
                        {getText("FeedBack", "प्रतिपुष्टि")}
                      </Link>
                    </li>
                  </> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sitemap;
